import React, { useState } from 'react';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import WidgetCard from './WidgetCard';
import { Link2 } from 'lucide-react';

function TickerDashboardGrid({ dashboardData, ticker }) {
  const [isLinked, setIsLinked] = useState(false);
  const [crosshairDate, setCrosshairDate] = useState(null);

  if (!dashboardData || !dashboardData.widgets) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-400">No widgets to display</p>
      </div>
    );
  }

  const widgets = dashboardData.widgets;

  // Create layout from widget data
  const layout = widgets.map(widget => ({
    i: String(widget.id),
    x: widget.grid_x ?? 0,
    y: widget.grid_y ?? 0,
    w: widget.grid_w ?? 6,
    h: widget.grid_h ?? 4,
    minW: 3,
    minH: 2,
  }));

  return (
    <div className="bg-background border border-muted rounded p-4" style={{ minHeight: '600px' }}>
      <div className="flex items-center gap-2 mb-3 pb-3 border-b border-muted">
        <input
          type="checkbox"
          id="link-charts-ticker"
          checked={isLinked}
          onChange={(e) => setIsLinked(e.target.checked)}
          className="w-4 h-4 cursor-pointer"
        />
        <label htmlFor="link-charts-ticker" className="text-text text-sm cursor-pointer select-none flex items-center gap-1.5">
          <Link2 className="w-4 h-4" /> Link All Charts (sync time range and crosshair)
        </label>

        <span className="text-xs text-gray-500 ml-4">
          {widgets.filter(w => w.use_dynamic_ticker).length} dynamic widget(s) showing <span className="text-primary font-medium">{ticker}</span>
        </span>
      </div>

      <GridLayout
        className="layout"
        layout={layout}
        cols={12}
        rowHeight={80}
        width={1100}
        isDraggable={false}  // READ-ONLY: No dragging
        isResizable={false}  // READ-ONLY: No resizing
        compactType="vertical"
        preventCollision={true}
      >
        {widgets.map(widget => (
          <div key={String(widget.id)}>
            <WidgetCard
              widget={widget}
              onDelete={() => {}} // No-op: Read-only view
              onUpdate={() => {}} // No-op: Read-only view
              isLinked={isLinked}
              crosshairDate={crosshairDate}
              onCrosshairMove={setCrosshairDate}
            />
          </div>
        ))}
      </GridLayout>
    </div>
  );
}

export default TickerDashboardGrid;
